import type {FlagProps} from 'platform/components';

import {getTrimOrderability} from '../../utils/getTrimOrderability';
import {getOrderabilityColorScheme} from './getOrderabilityColorScheme';
import {getTrimOrderabilityText} from './getTrimOrderabilityText';
import type {OrderabilityChipProps} from './OrderabilityChip';

export function getOrderabilityFlagProps(
  trim: OrderabilityChipProps['trim'],
  today: Date,
  formatDate: (date: Date) => string
): FlagProps {
  const result = getTrimOrderability(trim, today);
  return {
    label: getTrimOrderabilityText(trim, today, formatDate),
    colorScheme: getOrderabilityColorScheme(result),
    isSubtle: true,
  };
}
